module.exports = __webpack_public_path__ + "static/img/scene_photo_outdoor.0390742.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/scene_photo_outdoor.jpg
// module id = syfh
// module chunks = 1